import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=4c965d3e"
import script from "./Users.ts?vue&type=script&lang=ts&external"
export * from "./Users.ts?vue&type=script&lang=ts&external"
import style0 from "./Users.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports